import { useMemo } from "react";
import {
  PublicApiRedirectionRequestStatus,
  PublicApiRedirectionStatus,
} from "../../../common/data/service-proxies";
import { useTheme } from "@material-ui/core/styles";

type Props = {
  status: PublicApiRedirectionStatus | null | PublicApiRedirectionRequestStatus;
};

const RedirectedApiClientsStatusLabel = ({ status }: Props) => {
  const theme = useTheme();
  const labelColor = useMemo(() => {
    let color = null;
    switch (status) {
      case PublicApiRedirectionStatus.Pending:
      case PublicApiRedirectionRequestStatus.Pending:
        color = theme.palette.warning.main;
        break;
      case PublicApiRedirectionRequestStatus.Approved:
      case PublicApiRedirectionStatus.Active:
        color = theme.palette.success.main;
        break;
      case PublicApiRedirectionRequestStatus.Denied:
        color = theme.palette.error.main;
        break;
      default:
        color = theme.palette.grey[500];
        break;
    }
    return color;
  }, [status, theme]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        gap: "10px",
        alignItems: "center",
      }}
    >
      <div
        style={{
          width: "15px",
          height: "15px",
          borderRadius: "50%",
          backgroundColor: labelColor,
        }}
      />
      <p style={{ fontSize: "12px", color: labelColor }}>{status}</p>
    </div>
  );
};

export default RedirectedApiClientsStatusLabel;
